import { render, staticRenderFns } from "./RawMaterialsReceipt.vue?vue&type=template&id=1237c097&"
import script from "./RawMaterialsReceipt.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports